import CategoryModule from '@modules/Category';
import ParallaxModule from '@modules/Parallax';
import SmsEcap from '@utils/smsEcap';
import Care from '@modules/Care';
import loadTradeform from '@modules/tradeForm';
import loadLargeOrderForm from '@modules/largeOrderForm';
import RewardsTableSlider from '@modules/rewardsTableSlider';
import '../../style/templates/page.scss';
import '../../style/config/yotpo-widgets.scss';
import { pubSub } from '@utils/PubSub';
import { fetchLoyaltyDetails } from '@utils/loyaltyDetails';
import { SwymResults } from '@components/SwymResults';
import '@modules/DuoShop';

function displayUA(uaRes) {
  const uaDisplay = document.querySelector('#uaDisplay');
  const uaJSON = JSON.stringify(uaRes, null, 2);
  uaDisplay.innerHTML = uaJSON;
  uaDisplay.style.height = uaDisplay.scrollHeight + 'px';
}

function copyUa() {
  const uaDisplay = document.querySelector('#uaDisplay');
  const uaCta = document.querySelector('#uaCta');
  uaDisplay.select();
  document.execCommand('copy');
  uaCta.innerHTML = 'Copied!';
}

function resetUaCta() {
  setTimeout(() => {
    document.querySelector('#uaCta').innerHTML = 'Copy to Clipboard';
  }, 1000);
}

const triggerChat = async () => {
  const template = document.body;
  const isVariant = template.classList.contains('js-siena-enabled');

  try {
    if (isVariant) {
      window.SienaLaunchWidget();
    } else {
      window.Gladly.show();
    }
  } catch (error) {
    throw new Error(`Chat failed to load: ${error}`);
  }
};

/**
 * Appends the customer's points & tier to the server-rendered rewards header
 * once the loyalty API responds. Header copy itself is rendered in Liquid so it
 * never waits on Yotpo widgets.
 */
const initRewardsHeader = () => {
  const storySubheader = document.querySelector(
    '.rewards__header .story__subhead'
  );
  fetchLoyaltyDetails()?.then(() => {
    const pageCurrentPoints = window.Brooklinen.loyalty?.points_balance;
    const pageTier = window.Brooklinen.loyalty?.vip_tier_name;
    const pageTierText = pageTier
      ? ` <span class="t4" data-color="afternoon-delight-medium">${pageTier}</span> `
      : '';
    storySubheader.innerHTML += `<br/> <br/> You're currently a ${pageTierText} member with <span class="t4" data-color="afternoon-delight-medium">${pageCurrentPoints}</span> points.`;
  });
};

document.addEventListener('DOMContentLoaded', () => {
  pubSub.broadcast();
  new SwymResults();

  const categoryModule = document.querySelectorAll('.js-category-module');
  categoryModule.forEach((module) => new CategoryModule(module));

  const parallaxModule = document.querySelectorAll('.js-parallax-module');
  parallaxModule.forEach((module) => new ParallaxModule(module));

  const careModule = document.querySelectorAll('.js-care-module');
  careModule.forEach((module) => new Care(module));

  const smsEcapModule = document.querySelectorAll('.js-sms-ecap-module');
  smsEcapModule.forEach((module) => new SmsEcap(module));

  // Drawer can be dropped on any page, so key off the DOM not the url
  loadLargeOrderForm();

  // Load trade form and rewards modules on their respective page url
  if (window.location.pathname.includes('trade')) loadTradeform();
  else if (window.location.pathname.includes('pages/rewards')) {
    initRewardsHeader();

    // Rewards Tier Table Slider
    const tierSlider = document.querySelector('.tier-compare-mobile');
    new RewardsTableSlider(tierSlider);
  } else if (window.location.pathname.includes('pages/cart-support')) {
    setTimeout(() => triggerChat(), 0);
    document
      .querySelector('.themeHero .button--primary-inverse')
      .addEventListener('click', (e) => {
        e.preventDefault();
        setTimeout(() => triggerChat(), 0);
      });

    document
      .querySelector('.primaryHero .button--primary')
      .addEventListener('click', (e) => {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('cart:request'));
      });
  }

  // Load user agent logic
  if (document.querySelector('.module--ua')) {
    const parser = new UAParser(); //eslint-disable-line no-undef
    const uaRes = parser.getResult();
    delete uaRes.ua;
    delete uaRes.cpu;

    const DYready = setInterval(() => {
      if (typeof window.DY?.Audiences === 'object') {
        uaRes.debug = window.DY.Audiences.getUserAudiences().join();
        uaRes.device = window.DY.deviceInfo;
        displayUA(uaRes);
        clearInterval(DYready);
      }
    }, 100);
    // Stop if over 10 sec
    setTimeout(() => clearInterval(DYready), 10000);

    document.querySelector('#uaCta').addEventListener('mouseup', copyUa);
    document.querySelector('#uaCta').addEventListener('mouseout', resetUaCta);
  }
});
